export default { 
  Login: require('./Login').default,
  Registration: require('./Registration').default,
  ResetPassword: require('./ResetPassword').default,
  SendReset: require('./SendReset').default,
  EmailVerifikasi: require('./EmailVerifikasi').default,
  SuccessReset: require('./SuccessReset').default,
  MemberConfirmation: require('./MemberConfirmation').default,
}